"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_FR_TRANS = {
    'time picker': 'Choix du temps',
    'today': 'Aujourd\'hui',
    'set time': 'Modifier l\'heure',
    'close': 'Fermer',
    'confirm': 'Confirmer',
    'hour': 'Heure',
    'minute': 'Minute',
    'second': 'Seconde',
};
//# sourceMappingURL=fr.js.map


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/ng2-date-time-picker/locale/fr.js
// module id = ../../../../ng2-date-time-picker/locale/fr.js
// module chunks = 4